import { Pencil, Check, X } from "lucide-react";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { useToast } from "@/hooks/use-toast";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import useCountUp from "@/hooks/useCountUp";
const Stats = () => {
  const {
    totalGivenAway,
    updateSetting
  } = useSiteSettings();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState("");
  const {
    toast
  } = useToast();
  const { count, elementRef } = useCountUp({ end: totalGivenAway });
  useEffect(() => {
    const checkAdminStatus = async () => {
      const {
        data: {
          user
        }
      } = await supabase.auth.getUser();
      if (user) {
        const {
          data
        } = await supabase.from('user_roles').select('role').eq('user_id', user.id).eq('role', 'admin').single();
        setIsAdmin(!!data);
      }
    };
    checkAdminStatus();
  }, []);
  const handleEdit = () => {
    setEditValue(totalGivenAway.toString());
    setIsEditing(true);
  };
  const handleSave = async () => {
    const value = Number(editValue);
    if (isNaN(value) || value < 0) {
      toast({
        title: "Invalid amount",
        variant: "destructive"
      });
      return;
    }
    const success = await updateSetting('total_given_away', value);
    if (success) {
      toast({
        title: "Updated successfully"
      });
      setIsEditing(false);
    } else {
      toast({
        title: "Failed to update",
        variant: "destructive"
      });
    }
  };
  const handleCancel = () => {
    setIsEditing(false);
  };
  return <section className="py-4 md:py-6 px-4 relative overflow-hidden">
      <div className="container mx-auto max-w-4xl text-center relative">
        <div className="relative">
          <h2 className="text-3xl font-bold text-foreground mb-2">Given Away Since 2024</h2>
          

        
          
          {/* Pill-shaped amount container */}
          <div className="relative max-w-2xl mx-auto">
            <div ref={elementRef} className="relative border-2 border-primary/30 rounded-full px-12 py-8 backdrop-blur-sm bg-card/30">
              
              
              {isEditing ? <div className="flex items-center justify-center gap-2">
                  <span className="text-3xl font-bold text-primary">$</span>
                  <Input type="number" value={editValue} onChange={(e) => setEditValue(e.target.value)} className="w-40 text-center text-2xl font-bold" />
                  
                  <Button size="icon" variant="ghost" onClick={handleSave} className="text-green-500" aria-label="Save total given away">
                    <Check className="h-5 w-5" />
                  </Button>
                  <Button size="icon" variant="ghost" onClick={handleCancel} className="text-destructive" aria-label="Cancel editing total given away">
                    <X className="h-5 w-5" />
                  </Button>
                </div> : <div className="flex items-center justify-center gap-2">
                  <span className="text-4xl sm:text-6xl md:text-8xl font-display font-bold text-primary">
                    ${count.toLocaleString()}+
                  </span>
                  {isAdmin && <Button size="icon" variant="ghost" onClick={handleEdit} className="ml-2" aria-label="Edit total given away">
                      <Pencil className="h-5 w-5" />
                    </Button>}
                </div>}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Stats;